import React from 'react'
import moment from 'moment'

export const tableColumns = t => [
	{
		caption: t('restaurant_designer_section.strings.table_number'),
		dataField: 'tableNumber'
	},
	{
		caption: t('restaurant_designer_section.strings.hardware_id'),
		dataField: 'hardwareId'
	},
	{
		caption: t('restaurant_designer_section.strings.user_name'),
		dataField: 'userName'
	},
	{
		caption: t('restaurant_designer_section.strings.client_name'),
		dataField: 'clientName'
	},
	{
		caption: t('restaurant_designer_section.strings.last_modified'),
		dataField: 'lastModified',
		cellRender: ({ data: { lastModified } }) => {
			return (
				<div>{moment(lastModified).format('YYYY-MM-DD hh:mm:ss')}</div>
			)
		}
	}
]
